/**
 * @desc undefined
 */

import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type ExportBidDetailParameter = {
  compareId?: string
}

const method = 'GET'
const url = '/trade/priceCompareBid/export/bidDetail'

export const exportBidDetailApi = (
  params?: ExportBidDetailParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    params,
    ...config
  })
}

exportBidDetailApi.method = method
exportBidDetailApi.url = url
